import React, { useMemo } from 'react';

function sliderProgress(value) {
  return `${((value - 0.5) / 0.5) * 100}%`;
}

function Section1FilterIncidents({
  macroArea,
  consultant,
  fromPeriod,
  toPeriod,
  similarityThreshold,
  moduleOptions,
  consultantOptions,
  periodOptions,
  onMacroAreaChange,
  onConsultantChange,
  onFromPeriodChange,
  onToPeriodChange,
  onSimilarityChange,
  onApply,
  stats,
  applied,
  isApplying,
  filtersLoading,
}) {
  const sliderStyle = useMemo(
    () => ({ '--slider-progress': sliderProgress(similarityThreshold) }),
    [similarityThreshold]
  );

  return (
    <section className="nlp-grouping-card">
      <h2 className="nlp-section-title">1. Filter Incidents (Create Shortlist)</h2>

      <form
        className="nlp-filter-form"
        onSubmit={(e) => {
          e.preventDefault();
          onApply();
        }}
      >
        <div className="nlp-filter-grid">
          <label className="nlp-filter-field">
            <span className="nlp-filter-label">Macro Area / Module</span>
            <select
              value={macroArea}
              onChange={(e) => onMacroAreaChange(e.target.value)}
              disabled={filtersLoading}
            >
              {moduleOptions.map((opt) => (
                <option key={opt} value={opt}>{opt}</option>
              ))}
            </select>
          </label>

          <label className="nlp-filter-field">
            <span className="nlp-filter-label">Assigned Consultant</span>
            <select
              value={consultant}
              onChange={(e) => onConsultantChange(e.target.value)}
              disabled={filtersLoading}
            >
              {consultantOptions.map((opt) => (
                <option key={opt} value={opt}>{opt}</option>
              ))}
            </select>
          </label>

          <label className="nlp-filter-field">
            <span className="nlp-filter-label">From Period (ReqCrYM)</span>
            <select
              value={fromPeriod}
              onChange={(e) => onFromPeriodChange(e.target.value)}
              disabled={filtersLoading}
            >
              {periodOptions.map((opt) => (
                <option key={opt} value={opt}>{opt}</option>
              ))}
            </select>
          </label>

          <label className="nlp-filter-field">
            <span className="nlp-filter-label">To Period (ReqCrYM)</span>
            <select
              value={toPeriod}
              onChange={(e) => onToPeriodChange(e.target.value)}
              disabled={filtersLoading}
            >
              {periodOptions.map((opt) => (
                <option key={opt} value={opt}>{opt}</option>
              ))}
            </select>
          </label>
        </div>

        <div className="nlp-slider-field">
          <span className="nlp-filter-label">
            Vector Similarity Threshold: {similarityThreshold.toFixed(2)}
          </span>
          <input
            type="range"
            min="0.5"
            max="1"
            step="0.01"
            value={similarityThreshold}
            onChange={(e) => onSimilarityChange(Number(e.target.value))}
            className="nlp-slider"
            style={sliderStyle}
            disabled={filtersLoading}
          />
        </div>

        <button type="submit" className="nlp-primary-btn" disabled={isApplying || filtersLoading}>
          {filtersLoading ? 'Loading filters…' : isApplying ? 'Applying…' : 'Apply Filters (Go)'}
        </button>
      </form>

      {applied && stats && (
        <div className="nlp-kpi-grid">
          <div className="nlp-kpi-card">
            <span className="nlp-kpi-value">{stats.ticketCount}</span>
            <span className="nlp-kpi-label">Shortlist Distinct Tickets</span>
          </div>
          <div className="nlp-kpi-card">
            <span className="nlp-kpi-value">{stats.totalEffortHours.toLocaleString()} hrs</span>
            <span className="nlp-kpi-label">Total Cumulative Effort</span>
          </div>
        </div>
      )}
    </section>
  );
}

export default Section1FilterIncidents;
